import { Euler, Quaternion, Vector3 } from "three";
export const vectorDown = () => new Vector3(0, -1, 0);
export const vectorUp = () => new Vector3(0, 1, 0);
export const vectorForward = () => new Vector3(0, 0, -1);
export const vectorBack = () => new Vector3(0, 0, 1);
export const vectorRight = () => new Vector3(1, 0, 0);
export const vectorLeft = () => new Vector3(-1, 0, 0);
/**
 * Set the contents of Vector A to match Vector B.
 */
export function setVector(A, B) {
    A.x = B.x;
    A.y = B.y;
    A.z = B.z;
}
export function setQuaternion(A, B) {
    A.x = B.x;
    A.y = B.y;
    A.z = B.z;
    A.w = B.w;
}
export function addVectors(...vectors) {
    const result = new Vector3();
    for (const vector of vectors) {
        result.add(vector);
    }
    return result;
}
export function vectorTimes(A, s) {
    return new Vector3().addScaledVector(A, s);
}
export function subVectors(A, B) {
    return new Vector3().subVectors(A, B);
}
export function vectorToString(vec) {
    return `(${vec.x}, ${vec.y}, ${vec.z})`;
}
/**
 * Move vector A towards vector B
 */
export function moveVectorTowards(A, B, distance) {
    const distanceToCross = new Vector3().subVectors(A, B).length();
    if (distanceToCross === 0) {
        return;
    }
    const lerpFactor = Math.max(0, Math.min(1, distance / distanceToCross));
    A.lerpVectors(A, B, lerpFactor);
}
/**
 * Smoothly move vector A towards position B, which may be moving
 */
export function unboundedDampVectorTowards(source, target, acceleration, deltaTime, targetSpeed = 1) {
    targetSpeed = Math.max(targetSpeed, 0.1);
    const speed = 2 * acceleration * (new Vector3().subVectors(source, target).length()) / targetSpeed;
    moveVectorTowards(source, target, speed * deltaTime);
}
export function makeTransform(input) {
    var _a, _b;
    return {
        position: (_a = input.position) !== null && _a !== void 0 ? _a : new Vector3(0, 0, 0),
        quaternion: input.quaternion ? input.quaternion.clone() : input.rotation ? new Quaternion().setFromEuler(input.rotation) : new Quaternion(),
        rotation: input.rotation ? input.rotation.clone() : input.quaternion ? new Euler().setFromQuaternion(input.quaternion) : new Euler(),
        scale: (_b = input.scale) !== null && _b !== void 0 ? _b : new Vector3(1, 1, 1),
    };
}
/**
 * Makes Object3D look at position
 */
export function lookAt(transform, position) {
    setQuaternion(transform.quaternion, getLookAtRotation(transform, position));
}
export function getLookAtRotation(transform, position) {
    const diff = new Vector3().subVectors(position, transform.position);
    diff.normalize();
    const base = vectorForward();
    const lookAtRotation = new Quaternion();
    lookAtRotation.setFromUnitVectors(base, diff);
    return lookAtRotation;
}
export function getForwardVector(transform) {
    const result = new Vector3();
    transform.getWorldDirection(result);
    result.multiplyScalar(-1);
    return result;
}
export function getUpVector(transform) {
    const result = vectorUp();
    result.applyQuaternion(transform.quaternion);
    return result;
}
export function projectVectorOntoPlane(vec, planeNormal) {
    const norm = planeNormal.clone().normalize();
    norm.multiplyScalar(vec.dot(norm));
    return new Vector3().subVectors(vec, norm);
}
export function projectVectorOntoVector(vec, vec2) {
    const norm = vec2.clone().normalize();
    return norm.multiplyScalar(vec.dot(norm));
}
/**
 * Creates a fresh quaternion based on the input Euler
 */
export function quatFromEuler(euler) {
    const Q = new Quaternion();
    Q.setFromEuler(euler);
    return Q;
}
/**
 * Creates a fresh quaternion based on the input Euler props
 */
export function quatFromEulerProps(x, y, z, order) {
    return quatFromEuler(new Euler(x, y, z, order));
}
//# sourceMappingURL=SpatialUtils.js.map